const moment = require("moment");
const { ReportBehavior } = require("../services/Report_behavior.service");
import { Loading } from "element-ui"

const state = {
    charts: [],
    displayChart : false,
    displayText : false,
    prototype: {
        pie: {
            chart: {
                type: 'pie'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            series: [{
                name: 'จำนวนการค้นหา',
                colorByPoint: true,
                data: [],
                showInLegend: true,
                allowPointSelect: true
            }],
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        formatter: function() {
                            return '<b>'+ this.point.name +'</b> (' + this.point.percentage.toFixed(2) + '%)'
                        }
                    },
                    showInLegend: true
                }
            },
            tooltip: {
                formatter: function() {
                    return '<b>' + this.point.name + '</b><br>จำนวนการค้นหา: <b>' + formatNumber(this.y) + '</b> ครั้ง';
                }
            },
            exporting: {
                chartOptions: {
                    scale: 2,
                    chart: {
                    height: 440,
                    width: 1080
                    },
                },
                buttons: {
                  contextButton:{
                      menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                  }
                }
              },
            credits: {
                enabled: false
            }
        },
        column : {
            chart: {
                type: 'column',
                scrollablePlotArea: {
                    minWidth: 700,
                    scrollPositionX: 1
                }
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                title: {
                    text: ''
                }
            },
            yAxis: {
                min: 0,
                title: {
                    // text: 'จำนวนการค้นหา (ครั้ง)'
                    text: 'พฤติกรรมการค้นหาโปรโมชัน/ครั้ง'
                }
            },
            tooltip: {
                formatter: function() {
                    return '<b>' + this.x + '</b><br>จำนวนการค้นหา: <b>' + formatNumber(this.y) + '</b> ครั้ง';
                }
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [{
                name: "",
                colorByPoint: true,
                data: []
            }],
            legend: {
                enabled: false
            },
            exporting: {
                chartOptions: {
                    scale: 2,
                    chart: {
                    height: 440,
                    width: 1080
                    },
                },
                buttons: {
                  contextButton:{
                      menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
                  }
                }
            },
            credits: {
                enabled: false
            }
          },
    },
    month_th: [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
}

const actions = {
    async setChartData({commit}, formdata) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let report_type = formdata.report_type;
        if (formdata.provider_type == 'mobile') {
            let result = await ReportBehavior.getMobileReport(formdata);
            result.type_data = formdata.type_data;
            if (result.status == 200) {
                let chart_status = result.data.length ? true : false
                commit('SET_CHART_STATUS',chart_status)
                if (formdata.search_type == 'promotion_category') {
                    
                } else if (formdata.search_type == 'provider_id') {
                    
                } else if (formdata.search_type == 'min_price') {
                    
                } else if (formdata.search_type == 'max_price') {
                    
                } else if (formdata.search_type == 'voice_minute_amount') {
                    if(result.data[result.data.length - 1].name > 2000) {
                        result.data[result.data.length - 1].name = 'ULM'
                    }
                    
                } else if (formdata.search_type == 'voice_minute_price') {
                    
                } else if (formdata.search_type == 'internet_amount') {
                    if(result.data[result.data.length - 1].name > 50) {
                        result.data[result.data.length - 1].name = 'ULM'
                    }
                    
                } else if (formdata.search_type == 'internet_price') {

                } else if (formdata.search_type == 'internet_speed') {
                    if(result.data[result.data.length - 1].name > 1000) {
                        result.data[result.data.length - 1].name = 'ULM'
                    }
                } else if (formdata.search_type == 'number_of_service_days') {
                    result = formatNumberService(result);
                } else if (formdata.search_type == 'privilege') {
                    result = formatPrivilege(result);
                    var sortable = [];
                    for (var data in result.data) {
                        sortable.push([result.data[data], result.data[data].amount]);
                    }
                    if (formdata.order == 'ASC') {
                        sortable.sort(function(a, b) {
                            return a[1] - b[1];
                        });
                    } else {
                        sortable.sort(function(a, b) {
                            return b[1] - a[1];
                        });
                    }
                    for(let i = 0; i < sortable.length; i ++){
                        result.data[i] = sortable[i][0]
                    }
                }
                let chart_data = {
                    title: "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + formdata.type_data.search_label,
                    label: formdata.type_data.search_label
                }
                switch(report_type) {
                    case 'month':
                        chart_data.subtitle = "เดือน" + state.month_th[parseInt(moment(formdata.type_data.month).format('MM')) - 1] + " ปี พ.ศ. " + moment(formdata.type_data.month).add(543, 'y').format('YYYY');
                        break;
                    case 'year':
                        chart_data.subtitle = "ปี พ.ศ. " + moment(formdata.type_data.year).add(543, 'y').format('YYYY');
                        break;
                    case 'quarter':
                        chart_data.subtitle = "ไตรมาสที่ " + formdata.type_data.quarter + " ปี พ.ศ. " + moment(formdata.type_data.quarter_year).add(543, 'y').format('YYYY');
                        break;
                }
                chart_data.data = result.data
                commit('SET_EMPTY_CHART');
                commit('SET_PIE_DATA', chart_data);
                commit('SET_COLUMN_DATA', chart_data);
                setTimeout(function(){ loadingInstance.close() }, 250);
            } else {
                setTimeout(function(){ loadingInstance.close() }, 250);
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        } else {
            let result = await ReportBehavior.getBroadbandReport(formdata);
            result.type_data = formdata.type_data;
            if (result.status == 200) {
                let chart_status = result.data.length ? true : false
                commit('SET_CHART_STATUS',chart_status)
                if (formdata.search_type == 'promotion_category') {
                    
                } else if (formdata.search_type == 'provider_id') {
                    
                } else if (formdata.search_type == 'min_price') {
                    
                } else if (formdata.search_type == 'max_price') {
                    
                } else if (formdata.search_type == 'download_speed') {
                    
                } else if (formdata.search_type == 'upload_speed') {
                    
                } else if (formdata.search_type == 'service_on_top') {
                    result = formatService(result);
                    
                } else if (formdata.search_type == 'privilege') {
                    result = formatPrivilege(result);
                    var sortable = [];
                    for (var data in result.data) {
                        sortable.push([result.data[data], result.data[data].amount]);
                    }
                    if (formdata.order == 'ASC') {
                        sortable.sort(function(a, b) {
                            return a[1] - b[1];
                        });
                    } else {
                        sortable.sort(function(a, b) {
                            return b[1] - a[1];
                        });
                    }
                    for(let i = 0; i < sortable.length; i ++){
                        result.data[i] = sortable[i][0]
                    }
                }
                let chart_data = {
                    title: "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + formdata.type_data.search_label,
                    label: formdata.type_data.search_label
                }
                switch(report_type) {
                    case 'month':
                        chart_data.subtitle = "เดือน " + state.month_th[parseInt(moment(formdata.type_data.month).add(543, 'y').format('MM')) - 1] + " ปี " + moment(formdata.type_data.month).add(543, 'y').format('YYYY');
                        break;
                    case 'year':
                        chart_data.subtitle = "ปี " + moment(formdata.type_data.year).add(543, 'y').format('YYYY');
                        break;
                    case 'quarter':
                        chart_data.subtitle = "ไตรมาสที่ " + formdata.type_data.quarter + " ปี " + moment(formdata.type_data.quarter_year).add(543, 'y').format('YYYY');
                        break;
                }
                chart_data.data = result.data
                commit('SET_EMPTY_CHART');
                commit('SET_PIE_DATA', chart_data);
                commit('SET_COLUMN_DATA', chart_data);
                setTimeout(function(){ loadingInstance.close() }, 250);
            } else {
                setTimeout(function(){ loadingInstance.close() }, 250);
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        }
        
    }
}

const mutations = {
    month(state,obj){
        state.charts.pie.title.text = "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + obj.type_data.search_label
        state.charts.pie.subtitle.text = "เดือน " + state.month_th[parseInt(moment(obj.type_data.month).format('MM')) - 1] + " ปี " + moment(obj.type_data.month).add(543, 'y').format('YYYY');
        state.charts.pie.series[0].data = []
        state.charts.column.title.text = "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + obj.type_data.search_label
        state.charts.column.subtitle.text = "เดือน " + state.month_th[parseInt(moment(obj.type_data.month).format('MM')) - 1] + " ปี " + moment(obj.type_data.month).add(543, 'y').format('YYYY');
        state.charts.column.series[0].data = []
        state.charts.column.series[0].name = obj.type_data.search_label
        state.charts.column.xAxis.categories = []
        state.charts.column.xAxis.title.text = obj.type_data.search_label
        for (let i = 0; i < obj.data.length; i++) {
            let data = {
                name: formatNumber(obj.data[i].name),
                y: obj.data[i].amount,
                color: obj.data[i].color ? obj.data[i].color : "",
            }
            state.charts.pie.series[0].data.push(data)
            state.charts.column.series[0].data.push(data)
            state.charts.column.xAxis.categories.push(data.name)
        }
    },
    year(state,obj){
        state.charts.pie.title.text = "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + obj.type_data.search_label
        state.charts.pie.subtitle.text = "ปี " + moment(obj.type_data.year).add(543, 'y').format('YYYY')
        state.charts.pie.series[0].data = []
        state.charts.column.title.text = "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + obj.type_data.search_label
        state.charts.column.subtitle.text = "ปี " + moment(obj.type_data.year).add(543, 'y').format('YYYY')
        state.charts.column.series[0].data = []
        state.charts.column.series[0].name = obj.type_data.search_label
        state.charts.column.xAxis.categories = []
        state.charts.column.xAxis.title.text = obj.type_data.search_label
        for (let i = 0; i < obj.data.length; i++) {
            let data = {
                name: formatNumber(obj.data[i].name),
                y: obj.data[i].amount,
                color: obj.data[i].color ? obj.data[i].color : "",
            }
            state.charts.pie.series[0].data.push(data)
            state.charts.column.series[0].data.push(data)
            state.charts.column.xAxis.categories.push(data.name)
        }
    },
    quarter(state,obj){
        state.charts.pie.title.text = "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + obj.type_data.search_label
        state.charts.pie.subtitle.text = "ไตรมาสที่ " + obj.type_data.quarter + " ปี " + moment(obj.type_data.quarter_year).add(543, 'y').format('YYYY');
        state.charts.pie.series[0].data = []
        state.charts.column.title.text = "รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ  จาก" + obj.type_data.search_label
        state.charts.column.subtitle.text = "ไตรมาสที่ " + obj.type_data.quarter + " ปี " + moment(obj.type_data.quarter_year).add(543, 'y').format('YYYY');
        state.charts.column.series[0].data = []
        state.charts.column.series[0].name = obj.type_data.search_label
        state.charts.column.xAxis.categories = []
        state.charts.column.xAxis.title.text = obj.type_data.search_label
        for (let i = 0; i < obj.data.length; i++) {
            let data = {
                name: formatNumber(obj.data[i].name),
                y: obj.data[i].amount,
                color: obj.data[i].color ? obj.data[i].color : "",
            }
            state.charts.pie.series[0].data.push(data)
            state.charts.column.series[0].data.push(data)
            state.charts.column.xAxis.categories.push(data.name)
        }
    },
    SET_COLUMN_DATA(state, obj){
        // state.charts = [];
        let column = state.prototype.column;
        column.title.text = obj.title;
        column.subtitle.text = obj.subtitle;
        column.xAxis.title.text = obj.label;
        column.series[0].name = obj.label;
        column.series[0].data = []
        column.xAxis.categories = []
        let other = 0
        for (let i = 0; i < obj.data.length; i++) {
            if(i < 9){
                let data = {
                    name: formatNumber(obj.data[i].name),
                    y: obj.data[i].amount,
                    color: obj.data[i].color ? obj.data[i].color : "",
                }
                column.series[0].data.push(data)
                column.xAxis.categories.push(data.name)
            } else {
                other += obj.data[i].amount
            }
        }
        if(other > 0 ){
            let data = {
                name: 'others',
                y: other
            }
            column.series[0].data.push(data)
            column.xAxis.categories.push('others')
        }
        state.charts.push(column)
    },
    SET_PIE_DATA(state, obj){
        // state.charts = [];
        let pie = state.prototype.pie;
        pie.title.text = obj.title;
        pie.subtitle.text = obj.subtitle;
        pie.series[0].data = []
        let other = 0
        for (let i = 0; i < obj.data.length; i++) {
            if(i < 9) {
                let data = {
                    name: formatNumber(obj.data[i].name),
                    y: obj.data[i].amount,
                    color: obj.data[i].color ? obj.data[i].color : "",
                }
                pie.series[0].data.push(data)
            } else {
                other += obj.data[i].amount
            }
        }
        if (other > 0) {
            let data = {
                name: 'others',
                y: other
            }
            pie.series[0].data.push(data)
        }
        state.charts.push(pie)
    },
    SET_EMPTY_CHART(state) {
        state.charts = []
    },
    SET_CHART_STATUS(state,status){
        state.displayChart = status
        state.displayText = !status
    }
}

function formatPrivilege(privilege) {
    let obj = privilege.data[0]
    let result = {
        data: [],
        type_data: privilege.type_data
    }
    if (obj.content_amount) {
        result.data.push({
            name: "ความบันเทิง",
            amount: obj.content_amount
        });
    }
    if (obj.social_amount) {
        result.data.push({
            name: "โซเชียล",
            amount: obj.social_amount
        });
    }
    if (obj.mobile_amount) {
        result.data.push({
            name: "โทรศัพท์เคลื่อนที่",
            amount: obj.mobile_amount
        });
    }
    if (obj.game_amount) {
        result.data.push({
            name: "เกมส์",
            amount: obj.game_amount
        });
    }
    if (obj.wifi_amount) {
        result.data.push({
            name: "Wifi",
            amount: obj.wifi_amount
        });
    }
    if (obj.premium_amount) {
        result.data.push({
            name: "พรีเมียม",
            amount: obj.premium_amount
        });
    }
    if (obj.device_amount) {
        result.data.push({
            name: "อุปกรณ์",
            amount: obj.device_amount
        });
    }
    if (obj.other_amount) {
        result.data.push({
            name: "อื่นๆ",
            amount: obj.other_amount
        });
    }
    return result;
}

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

function formatNumberService(obj) {
    for (let  i = 0;  i < obj.data.length;  i++) {
        switch(obj.data[i].name) {
            case 'all':
                obj.data[i].name = 'ไม่ระบุจำนวนวัน';
                break;
            case '1':
                obj.data[i].name = 'น้อยกว่า 1 วัน';
                break;
            case '5':
                obj.data[i].name = '1-5 วัน';
                break;
            case '10':
                obj.data[i].name = '6-10 วัน';
                break;
            case '15':
                obj.data[i].name = '11-15 วัน';
                break;
            case '30':
                obj.data[i].name = '15-30 วัน';
                break;
            case 'other':
                obj.data[i].name = 'มากกว่า 30 วัน';
        }
    }
    return obj;
}

function formatService(obj) {
    for (let  i = 0;  i < obj.data.length;  i++) {
        switch(obj.data[i].name) {
            case 'all':
                obj.data[i].name = 'เลือกทั้งหมด';
                break;
            case 'content':
                obj.data[i].name = 'บริการความบันเทิง';
                break;
            case 'mobile':
                obj.data[i].name = 'บริการโทรศัพท์เคลื่อนที่';
                break;
            case 'wifi':
                obj.data[i].name = 'บริการ Wifi/Hotspot';
                break;
            case 'fixed':
                obj.data[i].name = 'บริการ Fixed Line';
                break;
            case 'device':
                obj.data[i].name = 'บริการอุปกรณ์อื่นๆ';
                break;
            case 'other':
                obj.data[i].name = 'บริการอื่นๆ';
                break;
        }
    }
    return obj;
}

export const Report_behavior = {
    namespaced: true,
    state,
    actions,
    mutations
  };
  